import { render, staticRenderFns } from "./RuntimeModal.vue?vue&type=template&id=2b757a74&scoped=true&"
import script from "./RuntimeModal.vue?vue&type=script&lang=js&"
export * from "./RuntimeModal.vue?vue&type=script&lang=js&"
import style0 from "./RuntimeModal.vue?vue&type=style&index=0&id=2b757a74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b757a74",
  null
  
)

export default component.exports